
import { useState } from "react";
import { User } from "@supabase/supabase-js";

export const useImpersonationState = () => {
  const [isImpersonating, setIsImpersonating] = useState<boolean>(false);
  const [originalUser, setOriginalUser] = useState<User | null>(null);

  return {
    isImpersonating,
    setIsImpersonating,
    originalUser,
    setOriginalUser
  };
};
